/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

function Divider({
  height = 0.5,
  color = "#E2E8F0",
  text,
  className,
  style = {},
}) {
  return (
    <div
      className={`hl ${className}`}
      style={{
        ...style,
        width: "100%",
        border: `${height}px solid ${color}`,
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      {text && (
        <span
          style={{
            background: "#E2E8F0",
            position: "absolute",
            top: "-8px",
            textAlign: "center",
            left: "50%",
            transform: "translate(-50%)",
            padding: "0 10px",
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: "0.9375rem",
            color: "rgb(0,0,0)",
          }}
        >
          {text}
        </span>
      )}
    </div>
  );
}
export default Divider;
